import React from "react";
import MasterLayout from "../../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../../components/Breadcrumb";
import AddBlogs from "./AddBlogs";

const AddBlogsLayout = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Add Blogs" />
      <AddBlogs />
    </MasterLayout>
  );
};

export default AddBlogsLayout;
